import { withAiAgentGuard } from "../../hoc/withAiAgentGuard";

import { LeadsSearchFiltersContainer } from "./LeadsSearchFiltersContainer";

export const LeadsSearchFiltersWithAgent = withAiAgentGuard(LeadsSearchFiltersContainer);
